import React from 'react'
import Text from '@component/Text/Text'
import Link from 'next/link'
import {useRouter} from 'next/router'

interface IProps {
    text?: string
    link: string
    onClick?: (e?: React.MouseEvent<HTMLAnchorElement>) => void
    className?: string
    textClassName?: string
    leftIcon?: React.ReactNode
    rightIcon?: React.ReactNode
    renderRight?: number | undefined
}

const MobileNavigationSubItem: React.FC<IProps> = ({
    text,
    link,
    onClick,
    className,
    textClassName,
    leftIcon,
    rightIcon,
    renderRight,
}) => {
    const router = useRouter()
    const currentPath = router?.asPath
    return (
        <Link
            href={link || ''}
            className={`px-[20px] py-[10px] cursor-pointer flex items-center gap-x-[5px] ${className}`}
            onClick={e => {
                if (link === currentPath && e?.cancelable) {
                    e?.preventDefault()
                } else {
                    onClick(e)
                }
            }}>
            {leftIcon && leftIcon}
            <Text className={`${textClassName} text-body2 text-gray02 dark:text-dark_gray02`}>{text}</Text>
            {renderRight && (
                <div className={'px-[4px] min-w-[14px] h-[14px] rounded-[7px] bg-red_shade dark:bg-dark_red_shade'}>
                    <Text className={'text-ti4 text-white text-center leading-[14px]'}>{renderRight}</Text>
                </div>
            )}
            {rightIcon && rightIcon}
        </Link>
    )
}

export default MobileNavigationSubItem
